import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubastasService {
  baseUrl = environment.baseUrl;
  private ultimoResultadoSubject = new BehaviorSubject<any>({});
  public ultimoResultado$ = this.ultimoResultadoSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  constructor(private httpClient: HttpClient) {}

  getSubasta(id) {
    return this.httpClient.get(this.baseUrl + '/subastas/' + id);
  }

  getSubastas() {
    return this.httpClient.get(this.baseUrl + '/subastas');
  }

  getLoteSeguido(id_lote: string) {
    return this.httpClient.get(this.baseUrl + '/lotes-seguidos/' + id_lote);
  }

  deleteLoteSeguido(id_lote: string) {
    return this.httpClient.delete(this.baseUrl + '/lotes-seguidos/' + id_lote);
  }

  postLoteSeguido(
    id: string,
    id_lote: string,
    notificar_sms: string,
    notificar_email: string,
    notificar_dispositivo: string
  ) {
    return this.httpClient
      .post<any>(this.baseUrl + '/lotes-seguidos/', {
        _id: id,
        _id_lote: id_lote,
        _notificar_sms: notificar_sms,
        _notificar_email: notificar_email,
        _notificar_dispositivo: notificar_dispositivo
      })
      .pipe(
        map(loteseguido => {
          return loteseguido;
        })
      );
  }

  getCantidadUsuariosLotes(id_lote: string) {
    return this.httpClient.get(
      this.baseUrl + '/cantidad-usuarios-lote/' + id_lote
    );
  }

  getDepartamentos() {
    return this.httpClient.get(this.baseUrl + '/departamentos');
  }

  getCategorias() {
    return this.httpClient.get(this.baseUrl + '/categorias');
  }

  getSubastasParametros(categoriaList, marcasList, departamentoList, periodo) {
    return this.httpClient.post<any>(this.baseUrl + '/subastas-filtrado', {
      _categorias: categoriaList,
      _marcas: marcasList,
      _departamentos: departamentoList,
      _periodo: periodo
    });
  }

  getUltimoPeriodo() {
    return this.httpClient.get(this.baseUrl + '/periodo-actual');
  }

  getSubastasByPeriodo(idPeriodo) {
    return this.httpClient.get(this.baseUrl + '/subastas-periodo/' + idPeriodo);
  }

  getPeriodos() {
    return this.httpClient.get(this.baseUrl + '/periodos');
  }

  getSubastaGanador(idLote) {
    return this.httpClient.get(this.baseUrl + '/subasta-ganador/' + idLote);
  }

  getSeguidoresLote(idLote) {
    return this.httpClient.get(this.baseUrl + '/seguidores-lote/' + idLote);
  }

  setUltimoResultado(data) {
    this.ultimoResultadoSubject.next(data);
  }

  public fechaMysqlAfechaJs(fecha) {
    if (typeof fecha !== 'undefined') {
      return fecha
        .replace(/-/g, '/')
        .replace('T', ' ')
        .replace(/\..*|\+.*/, '');
    }
  }
}
